var render = function render(){var _vm=this,_c=_vm._self._c;return _c('details',{staticClass:"mce-accordion",on:{"toggle":_vm.toggle}},[_c('summary',[_c('font-awesome-icon',{style:({ color: '#1662AC' }),attrs:{"icon":_vm.icon}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.summary)}})],1),_c('div',{staticClass:"mce-accordion-body",domProps:{"innerHTML":_vm._s(_vm.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }